import { toast } from "sonner";
import { ArrowUpCircle, Lock, Check, Palette } from "lucide-react";
import { useClicker, CoinBar, fmtCoins, blip } from "./ClickerLayout";

export default function ClickerUpgrades() {
  const { state, config, action, muted } = useClicker();
  if (!config) return null;
  const buy = async (id) => { const d = await action("/clicker/upgrade", { id }); if (d) { blip(muted, 990, 0.12, "square"); toast.success(`${config.upgrades[id].name} upgraded`); } };
  const skin = async (s) => { const d = await action("/clicker/skin", { id: s.id }); if (d) toast.success(`${s.name} equipped`); };
  return (
    <div className="space-y-6" data-testid="clicker-upgrades">
      <CoinBar />
      <section className="space-y-2">
        <h2 className="font-black text-base flex items-center gap-2"><ArrowUpCircle className="w-4 h-4 text-[#00F0FF]" /> Upgrades shop</h2>
        {Object.entries(config.upgrades).map(([id, u]) => {
          const cost = state.upgrade_costs[id]; const can = state.coins >= cost;
          return (
            <div key={id} className="rounded-2xl bg-white/5 border border-white/10 p-4 flex items-center gap-3" data-testid={`clicker-upgrade-${id}`}>
              <div className="flex-1">
                <div className="font-bold">{u.name} <span className="text-[#00F0FF] text-xs">Lv {state.upgrades[id] || 0}</span></div>
                <div className="text-[11px] text-white/50">{u.desc}</div>
              </div>
              <button onClick={() => buy(id)} disabled={!can} data-testid={`clicker-upgrade-buy-${id}`}
                className="min-w-[88px] font-black text-xs px-3 py-2 rounded-full bg-[#FFE300] text-black disabled:bg-white/10 disabled:text-white/40 transition-colors">
                {fmtCoins(cost)}
              </button>
            </div>
          );
        })}
      </section>
      <section>
        <h2 className="font-black text-base flex items-center gap-2 mb-2"><Palette className="w-4 h-4 text-[#FF2BD6]" /> Clicker skins</h2>
        <div className="grid grid-cols-2 gap-2">
          {config.skins.map((s) => {
            const owned = state.skins.includes(s.id); const active = state.skin === s.id; const locked = state.level < s.level;
            return (
              <button key={s.id} onClick={() => skin(s)} disabled={active || (!owned && (locked || state.coins < s.cost))}
                data-testid={`clicker-skin-${s.id}`}
                className={`rounded-2xl p-3 text-left border transition-colors ${active ? "border-[#FF2BD6] bg-[#FF2BD6]/10" : "border-white/10 bg-white/5 hover:border-white/30"} disabled:cursor-default`}>
                <div className="font-bold text-sm">{s.name}</div>
                <div className="text-[10px] text-white/50">+{Math.round((s.bonus - 1) * 100)}% tap power</div>
                <div className="text-[11px] mt-1 font-black flex items-center gap-1">
                  {active ? <><Check className="w-3 h-3 text-[#39FF14]" /> Equipped</> : owned ? "Equip" : locked ? <><Lock className="w-3 h-3" /> Level {s.level}</> : `${fmtCoins(s.cost)} coins`}
                </div>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
